import { createContext } from "react";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import Sale from "../../../../utilities/data/model/Sale";
import Terminal from "../../../../utilities/data/model/Terminal";

export type Totals = {
  totalPrice: number;
  totalBasePrice: number;
  totalTax: number;
  totalDiscount: number;
};

export type CheckoutContextType = {
  terminal: Terminal;
  sale: Sale;
  balance: number;
  selectablePaymentMethods: PaymentMethod[];
  cashManagedPaymentMethod: PaymentMethod;
  roundingPaymentMethod: PaymentMethod;
  giftVoucherPaymentMethod: PaymentMethod;
  totals: Totals;
};

export const CheckoutContext = createContext<CheckoutContextType | undefined>(
  undefined
);
